import {
    ChildTaskListResponse,
    DependentTaskDetailResponseList,
    EpicsForListingResponse,
} from "../../models/task-response";
import { CommentResponse } from "../../../../models/comment-response";
import {
    GetAllEnvironmentSeverityResolution,
    Resolution,
} from "../../../shared/Models/task.model";
import { APIResponse } from "src/app/models/Response";
import { SprintsListWithSortResponse } from "../../../admin/sprint/models/sprint.model";
import { UserDetails } from "../../../../models/userDetails";
import {ReleaseForTaskResponse} from "../../../release/models/release.model";

export class UpdateTaskModel {}

export class TaskHistory {
    modifiedDateString: string | undefined;
    modifications: TaskModification[];
    fieldName: { [key: string]: string } = {};
    modifiedBy: string;
    modifiedOn: string;
    newValue: { [key: string]: string };
    oldValue: { [key: string]: string };
    message: { [key: string]: string };
    taskNumber: number;
    version: number;

    constructor(data: any) {
        this.fieldName = data.fieldName;
        this.modifiedBy = data.modifiedBy;
        this.modifiedOn = data.modifiedOn;
        this.newValue = data.newValue;
        this.oldValue = data.oldValue;
        this.message = data.message;
        this.taskNumber = data.taskNumber;
        this.version = data.version;
        this.modifiedDateString = this.modifiedOn ? String(new Date(this.modifiedOn)) : undefined;
        this.modifications = Object.keys(this.fieldName).reduce((acc: TaskModification[], key: string) => {
            if (
                this.oldValue.hasOwnProperty(key) &&
                this.newValue.hasOwnProperty(key) &&
                this.message.hasOwnProperty(key)
            ) {
                const modification = new TaskModification(
                    this.fieldName[key],
                    this.oldValue[key] || "No Value",
                    this.newValue[key] || "No Value",
                    this.message[key] || "No Value",
                );
                acc.find((item: TaskModification) => item.fieldName === modification.fieldName)
                    ? null
                    : acc.push(modification);
            }
            return acc;
        }, [] as TaskModification[]);
    }
}

export class TaskModification {
    constructor(
        public fieldName: string,
        public oldValue: string | null,
        public newValue: string,
        public message: string,
    ) {}
}

export class TaskHistoryMappingFields {
    fieldDescription: string;
    fieldKey: number;

    constructor(data: any) {
        this.fieldDescription = data.columnsDesc;
        this.fieldKey = data.taskHistoryColumnsMappingKey;
    }
}

export class TaskNotesModel {
    noteLogId: number | null = null;
    note: string | null = null;
    noteId: number | null = null;
    postedByAccountId: number | null = null;
    modifiedByAccountId: number | null = null;
    createdDateTime: string | null = null;
    lastUpdatedDateTime: string | null = null;
    version: number | null = null;
    isDeleted: number | null = null;
    isUpdated: number | null = null;

    constructor(note: string, postedByAccountId: number) {
        this.note = note;
        this.postedByAccountId = postedByAccountId;
    }
}

export class TaskDeliverablesModel {
    deliverablesDeliveredLogId: number | null = null;
    deliverablesDelivered: string;
    listOfDeliverablesDeliveredId: number | null = null;
    createdByAccountId: number;
    updatedByAccountId: number | null = null;
    createdDateTime: string | null = null;
    lastUpdatedDateTime: string | null = null;
    version: number | null = null;
    isDeleted: number | null = null;
    isUpdated: number | null = null;

    constructor(deliverablesDelivered: string, createdByAccountId: number) {
        this.deliverablesDelivered = deliverablesDelivered;
        this.createdByAccountId = createdByAccountId;
    }
}

export type AddEditTextDialogDataModel = {
    isModify: boolean;
    text: string;
    placeholder: string;
    headerText: string;
    maxLength: number;
};

export const UpdateTaskConstants = {
    DELETE_TASK_TITLE: "Delete Work Item",
    DELETE_SUB_TASK_TITLE: "Delete Child Task",
    DELETE_TASK_CONFIRMATION: "All unsaved changes will be ignored. Do you want to delete this Work Item?",
    DELETE_TASK_SUCCESS_MESSAGE: "Work Item deleted successfully.",
    DELETE_TASK_ERROR_MESSAGE: "Error occurred while deleting Work Item.",
    TASK_ALREADY_DELETED_ERROR_MESSAGE: "It seems task is already deleted.",
    DELETE_LAST_SUB_TASK_CONFIRMATION:
        "Deletion of this Child Task will mark its parent task as deleted." +
        " In case you wish to continue using its Parent Task, create a new Child Task first before deleting this Child Task." +
        " Do you wish to continue with deletion of this Child Task?",
    DELETE_PARENT_TASK_CONFIRMATION:
        "All the Child Work Items, other than completed Child Work Items, would be deleted along with this Parent Work Item. Also, All unsaved changes will be ignored. Do you wish to continue?",
    DELETE_TASK_CONFIRMATION_CONTINUE_BUTTON_TEXT: "Delete",
    REMOVE_CONFIRMATION_CONTINUE_BUTTON_TEXT: "Remove",
    DELETE_REFERENCED_TASK_CONFIRMATION:
        "This work item has reference/dependency work items. Press Continue to Delete this Work Item and the links to reference/dependency work items will also be deleted. Also, All unsaved changes will be ignored.",
    REMOVE_DEPENDENCY_CONFIRMATION_TITLE: "Remove Dependency form Work Item",
    REMOVE_DEPENDENCY_CONFIRMATION_MESSAGE: "Are you sure you want to remove this dependency?",
    REMOVE_REFERENCE_CONFIRMATION_TITLE: "Remove Reference form Work Item",
    REMOVE_REFERENCE_CONFIRMATION_MESSAGE: "Are you sure you want to remove this reference?",
    DELETE_TASK_TITLE_NOT_STARTED_SPRINT: "Confirmation",
    DELETE_TASK_CONFIRMATION_NOT_STARTED_SPRINT: "This work item would be removed from the sprint it is present in. Press Yes to continue or Cancel to cancel",
    DELETE_TASK_NOT_STARTED_SPRINT_CONFIRMATION_CONTINUE_BUTTON_TEXT: "Yes",
    DELETE_TASK_NOT_STARTED_SPRINT_CONFIRMATION_CANCEL_BUTTON_TEXT: "Cancel"
};

export class EstimateModel {
    hours: number;
    minutes: number;
    stringValue: string;
    title?: string;
    showResetButton: boolean;
}

export class SubTaskRequestModel {
    taskNumber: number | null = null;
    taskTitle: string;
    taskDesc: string | null = null;
    taskExpStartDate: string | null = null;
    taskExpEndDate: string | null = null;
    taskEstimate: number | null = null;
    accountIdAssigned: number | null = null;
    taskProgressSystem: number | null = null;
    systemDerivedEndTs: string | null = null;
    userPerceivedPercentageTaskCompleted: number | null = null;
    recordedEffort: number | null = null;
    workflowTaskStatus: number | null = null;
    parentTaskId: number | null = null;
}

export class UpdatedTaskPreviewResponse {
    version: number;
    lastUpdatedDateTime: string;
    childTaskIds: number[];
    taskProgressSystem: string | null = null;
    taskProgressSystemLastUpdated: string | null = null;
    dependencyIds: number[] | null = null;
    taskEstimate: number | null = null;
    nextTaskProgressSystemChangeDateTime: string | null = null;
    meetingList: number[] | null = null;
}

export class SubTaskEmitterResponse {
    childTask: ChildTaskListResponse;
    taskPreview: UpdatedTaskPreviewResponse;
}

export class ParentTaskResponseInSubTask {
    taskNumber: string;
    taskId: number;
    taskTitle: string;
    taskProgressSystem: string;
    taskDesc: string;
    taskExpStartDate: string;
    taskExpEndDate: string;
    taskEstimate: number;
    accountIdAssigned: number;
    systemDerivedEndTs: string;
    userPerceivedPercentageTaskCompleted: number;
    recordedEffort: number;
    workflowTaskStatus: string;
    childTaskIds: number[];
}

export class TaskTimeFieldsModel {
    taskExpectedStartTime: string = "";
    taskExpectedEndTime: string = "";
    taskActualStartTime: string = "";
    taskActualEndTime: string = "";
    taskCompletionTime: string = "";
}

export class TaskDateFieldsModel {
    taskExpectedStartDate: string = "";
    taskActualStartDate: string = "";
    taskExpectedEndDate: string = "";
    taskActualEndDate: string = "";
    taskCompletionDate: string = "";
}

export class UpdateExistingTaskDependenciesEventEmitter {
    existingTaskDependencies: DependentTaskDetailResponseList[] = [];
    taskPreviewResponse: UpdatedTaskPreviewResponse;
}

export class AddCommentEvent {
    comment: CommentResponse | null;
    editorEventEmitter: AddCommentEditorEventEmitter;
}

export class AddCommentEditorEventEmitter {
    text: string;
    files: File[] = [];
}

export class TaskBlockReasonTypeObject {
    reasonTypeId: number;
    message: string;
}

export const TASKBLOCKREASONS: TaskBlockReasonTypeObject[] = [
    { reasonTypeId: 2, message: "Awaiting input from Internal Team" },
    { reasonTypeId: 5, message: "Awaiting input from Other Team" },
    { reasonTypeId: 1, message: "Awaiting input from External Source" },
    { reasonTypeId: 3, message: "Other Reason" },
];

export const TASK_CONSTANTS = {
    TASK_DESCRIPTION_MAX_LENGTH: 5000,
    TASK_DESCRIPTION_MIN_LENGTH: 3,
    TASK_TITLE_MAX_LENGTH: 70,
    TASK_TITLE_MIN_LENGTH: 3,
};

export const WORK_ITEM_UPDATE_FORM = {
    EXP_START_DATE: "taskExpStartDate",
    EXP_END_DATE: "taskExpEndDate",
    ACTUAL_START_DATE: "taskActualStartDate",
    ACTUAL_END_DATE: "taskActualEndDate",
    PRIORITY: "priority",
    WORKFLOW_STATUS: "workflowStatus",
    ASSIGNED_TO: "assignTo",
    CURRENTLY_SCHEDULED_TASK_INDICATOR: "currentlyScheduledTaskIndicator",
    CURRENTLY_ACTIVITY_INDICATOR: "currentlyActivityIndicator",
    IMMEDIATE_ATTENTION: "immediateAttention",
    IMMEDIATE_ATTENTION_REASON: "immediateAttentionReason",
    IMMEDIATE_ATTENTION_TO_PERSON: "immediateAttentionFrom",
    SPRINT_ID: "sprintId",
    MENTOR_1: "mentor1",
    MENTOR_2: "mentor2",
    OBSERVER_1: "observer1",
    OBSERVER_2: "observer2",
    TASK_ESTIMATE: "taskEstimate",
    EPIC_ID: "epicId",
    RELEASE_ID: "releaseId",
};

export class AskBugFieldsDialogData {
    resolutionsDropDownData: Resolution[];
    parentBugTaskNumber: string | null;
    parentBugTaskIdentifier: number | null;
    orgId: number;
    teamId: number;
}

export class AskBugFieldsDialogResponse {
    resolution: number;
    stepsTakenToResolve: string;
    rcaId: number;
    isRcaDone: boolean | null;
    rcaReason: string | null;
    rcaIntroducedBy: number[] | null;
}

export class PerfUserAccount {
    email!: string;
    accountId!: number;
    firstName!: string;
    lastName!: string;

    constructor(data?: Partial<PerfUserAccount>) {
        if (data) {
            Object.assign(this, data);
        }
    }
}

export class TaskInfo {
    taskNumber!: string;
    taskId!: number;
    taskTitle!: string;
    taskDesc!: string;
    teamId!: number;

    constructor(data?: Partial<TaskInfo>) {
        if (data) {
            Object.assign(this, data);
        }
    }
}

export class TaskRating {
    taskRatingId!: number;
    taskRatingDesc!: string;
    taskRating!: number;
    taskRatingDisplayAs!: string;
    createdDateTime!: string;
    lastUpdatedDateTime!: string | null;

    constructor(data?: Partial<TaskRating>) {
        if (data) {
            Object.assign(this, data);
        }
    }
}

export class PerformanceFeedback {
    perfNoteId!: number;
    perfNote!: string;
    postedByAccount!: PerfUserAccount;
    assignedToAccount!: PerfUserAccount;
    isShared!: boolean;
    isPrivate!: boolean;
    taskInfo!: TaskInfo;
    fkTaskRatingId!: TaskRating | null;
    modifiedByAccount!: PerfUserAccount | null;
    createdDateTime!: string;
    lastUpdatedDateTime!: string;
    version!: number;

    constructor(data?: Partial<PerformanceFeedback>) {
        if (data) {
            Object.assign(this, data);
            this.postedByAccount = new PerfUserAccount(data.postedByAccount);
            this.assignedToAccount = new PerfUserAccount(data.assignedToAccount);
            this.taskInfo = new TaskInfo(data.taskInfo);
            this.fkTaskRatingId = data.fkTaskRatingId ? new TaskRating(data.fkTaskRatingId) : null;
            this.modifiedByAccount = data.modifiedByAccount ? new PerfUserAccount(data.modifiedByAccount) : null;
        }
    }
}

export class IPerformanceFeedbackRequest {
    perfNote: string;
    postedByAccountId: number;
    assignedToAccountId: number;
    isShared: boolean;
    isPrivate: boolean;
    isDeleted: boolean;
    taskId: number;
    taskRatingId: number | null;
    modifiedByAccountId: number | null;
}

export interface TaskRatings {
    taskRatingId: number;
    taskRatingDesc: string;
    taskRating: number;
    taskRatingDisplayAs: string;
    createdDateTime: string;
    lastUpdatedDateTime: string | null;
}

export class GetPerformanceFeedbacksByFilterRequest {
    taskNumber!: string | null;
    assignedTo!: number;
    postedBy!: number | null;
    fromDate!: string | null;
    toDate!: string | null;

    constructor(data?: Partial<GetPerformanceFeedbacksByFilterRequest>) {
        if (data) {
            Object.assign(this, data);
        }
    }
}

export class PerformanceFeedbackHistory {
    perfNoteId: number;
    perfNote: string;
    isShared: boolean;
    isPrivate: boolean;
    fkTaskRatingId: TaskRating | null;
    modifiedByAccount: PerfUserAccount | null;
    createdDateTime: string;
    version: number;
}

export interface EstimateDrillDownForParentTaskResponse {
    totalParentTaskEstimate: number;
    currentChildTasks: CurrentChildWorkItems;
    deletedChildTasks: DeletedChildWorkItems;
}

export interface CurrentChildWorkItems {
    [taskId: string]: number; // taskId (e.g., "T39-2215") as key, and task estimate (e.g., 120) as value
}

export interface DeletedChildWorkItems {
    [taskId: string]: DeletedWorkItemDetail; // taskId (e.g., "T39-2216") as key, and a detailed object as value
}

export interface DeletedWorkItemDetail {
    estimateIncludedInParentTask: number;
    taskEstimate: number;
    userPerceivedPercentageCompleted: number;
}

export type SubWorkItemsStatus = {
    [taskId: string]: string;
};

export interface FetchSprintEpicAndBugDetailsResult {
    sprintsResponse: APIResponse<SprintsListWithSortResponse[]>;
    epicsResponse: APIResponse<EpicsForListingResponse>;
    bugFieldsResponse: APIResponse<GetAllEnvironmentSeverityResolution> | null;
    releasesForTaskResponse: APIResponse<ReleaseForTaskResponse[]>;
}

export interface MentorsObserversImmediateAttentionAttachmentsResult {
    mentorsResponse: APIResponse<UserDetails[]>;
    observersResponse: APIResponse<UserDetails[]>;
    immediateAttentionUsersResponse: APIResponse<any>;
    voiceAttachmentResponse: Blob | null;
    performanceNotesResponse: APIResponse<PerformanceFeedback[]> | null;
}

export interface DialogIdentifiable {
    readonly dialogId: string;
}
export const DIALOG_IDS = {
    WORK_ITEM: 'work-item-dialog',
} as const;

export const TASK_BLOCK_REASON_IDS = {
    INTERNAL_TEAM: 2,
    OTHER_TEAM: 5,
    EXTERNAL_SOURCE: 1,
    OTHER_REASON: 3,
};